import { Field } from 'vant';
import { Grid, GridItem } from 'vant';
import { Tab, Tabs } from 'vant';


export default {
    install(Vue) {
        Vue.use(Field)
        Vue.use(Grid);
        Vue.use(GridItem);
        Vue.use(Tab);
        Vue.use(Tabs);
    }
}




// WEBPACK FOOTER //
// ./src/utils/vant.js